import React, { useCallback } from "react";
import { hideVideoMenu, showVideoMenu } from "../../plugins/video-menu-plugin";
import { EditorVideo } from "../EditorVideo/EditorVideo";
export const VideoNodeView = ({ view, attrs, getPos, service, }) => {
    const handleChangeMenuVisibility = useCallback((visible, target) => {
        if (visible) {
            showVideoMenu(view, target.closest(".editor-video"));
        }
        else {
            hideVideoMenu(view);
        }
    }, [view]);
    if (attrs.url) {
        return (React.createElement("div", { className: "editor-video-placeholder" },
            React.createElement("video", { autoPlay: false, controls: false },
                React.createElement("source", { src: attrs.url }))));
    }
    return (React.createElement(EditorVideo, { attrs: attrs, service: service, editable: view.editable, onChangeMenuVisibility: handleChangeMenuVisibility }));
};
